module.exports = __webpack_public_path__ + "img/pay_debit.50956113.png";